var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIron = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 80 80"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#db011c",
  "data-name": "Group 32878"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 32877"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 32875"
}, /*#__PURE__*/React.createElement("path", {
  d: "M62.669 54.74H14.786l2.619-29.481h28.159a1.967 1.967 0 0 1 0 3.934H21.005l-1.92 21.612h43.584a1.967 1.967 0 0 1 0 3.934Z",
  "data-name": "Path 19146"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.09 51.896c-1.1-7.521-10.009-13.6-20.715-14.137-2.156-.108-3.864-.113-5.671-.119l-2.319-.014c-2.047-.019-4.854-.045-6.594.132a17.56 17.56 0 0 0-7.653 2.584l-.3.163-.945-1.725.3-.162a19.4 19.4 0 0 1 8.4-2.817c1.849-.188 4.718-.162 6.811-.142l2.308.014c1.832.006 3.563.011 5.764.122 11.817.594 21.306 7.246 22.564 15.816Z",
  "data-name": "Path 19147"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 32876"
}, /*#__PURE__*/React.createElement("path", {
  d: "m17.032 61.543 44.146-44.472 1.396 1.385L18.428 62.93z",
  "data-name": "Rectangle 26177"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17.038 18.45 1.396-1.385L62.57 61.548l-1.397 1.386z",
  "data-name": "Rectangle 26178"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M80 80H0V0h80ZM1.311 78.688h77.377V1.311H1.311Z",
  "data-name": "Path 19148"
}))));
export default SvgIron;